import React, { useEffect, useState } from "react";
import AlertField from "../Components/AlertField";
import useAxiosPrivate from "../Hooks/useAxiosPrivate";
import Paginate from "../Components/Paginate";
import Records from "../Components/Records";

const Medicine = () => {
  const [alert, setAlert] = useState(null);
  const axiosPrivate = useAxiosPrivate();
  const [pageCount, setpageCount] = useState(0);
  const [count, setCount] = useState(0);
  const [endValue, setEndValue] = useState(0);
  const [limit, setLimit] = useState("10");
  const [startValue, setStartValue] = useState(1);
  const [medicine, setMedicine] = useState("");
  const [value, setValue] = useState({});
  const [filter, setFilter] = useState("");
  const [cancelActive, setCancelActive] = useState(false);

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });

    setTimeout(() => {
      setAlert(null);
    }, 5000);
  };

  const onChange = (e) => {
    setMedicine(e.target.value);
  };

  useEffect(() => {
    getIntitalData(limit, filter);
  }, []);

  const getIntitalData = async (limit, filter) => {
    try {
      const response = await axiosPrivate.get(
        `prescription/medicine/list?limit=${limit}&search=${filter}`
      );

      //sets the list of data got from api
      setValue(response?.data.results);
      //gets the total record and divides by 10 to set pagination number
      setpageCount(Math.ceil(response.data.count / 10));
      //sets the total number of record to display in bottom message
      setCount(response?.data.count);
      //sets the start and end value as length of records got
      setStartValue(1);
      setEndValue(response?.data.results.length);
    } catch (err) {
      if (!err?.response) {
        showAlert("No Server Response", "warning");
      } else {
        showAlert("Load Failed", "warning");
      }
    }
  };

  const addMedicine = async () => {
    if (medicine !== "") {
      try {
        await axiosPrivate.post("prescription/medicine", {
          medicine_name: medicine,
        });
        showAlert("Medicine Added", "success");
        setMedicine("");
        getIntitalData(limit, filter);
      } catch (err) {
        if (!err?.response) {
          showAlert("No Server Response", "warning");
        } else if (err.response?.status === 400) {
          showAlert(err.response?.data["message"], "warning");
        } else if (err.response?.status === 401) {
          showAlert("You do not have access.", "warning");
        } else {
          showAlert("Add Failed", "warning");
        }
        setMedicine("");
      }
    } else {
      showAlert("Add medicine name.", "warning");
    }
  };

  const getList = async (limit, offset, filter) => {
    //it gets the value of limit to get number of records
    const res = await axiosPrivate.get(
      `prescription/medicine/list?limit=${limit}&offset=${offset}&search=${filter}`,
      {}
    );
    return res;
  };

  const handlePageClick = async (data) => {
    let currentPage = data.selected * limit;
    //calls the api with limit and currentpage as offset and get response data
    const response = await getList(limit, currentPage, filter);

    //sets response into list
    setValue(response?.data.results);
    //sets start and end value
    setStartValue(data.selected * limit + 1);
    setEndValue(data.selected * limit + response?.data.results.length);
    //sets 0 to start and end value if records on response is 0
    if (response?.data.results.length === 0) {
      setStartValue(0);
      setEndValue(0);
    }
  };

  const handleRecordClick = async (data) => {
    //make sure api does not hit when record value is same
    if (data.target.value !== limit) {
      //calls the api with new limit chosen
      getIntitalData(data.target.value, filter);
      setLimit(data.target.value);
    }
  };

  const search = async (e) => {
    if (e.key === "Enter") {
      //replaces white space with %20
      const filter = e.target.value.replace(/\s/g, "%20");
      setFilter(filter);
      getIntitalData(limit, filter);

      //activates the reset filter button
      setCancelActive(true);
    }
  };

  const onCancel = () => {
    //hides the reset filter button
    setCancelActive(false);
    setFilter("");
    getIntitalData(limit, "");
    // sets the value of search button to null
    const inputState = document.getElementById("filterTable");
    inputState.value = "";
  };

  const onDelete = async (id) => {
    try {
      await axiosPrivate.delete(`prescription/medicine/delete/${id}/`);
      showAlert("Medicine Deleted.", "success");
      getIntitalData(limit, filter);
    } catch (err) {
      if (!err?.response) {
        showAlert("No Server Response", "warning");
      } else {
        showAlert("Delete Failed", "warning");
      }
    }
  };

  return (
    <div>
      <AlertField alert={alert} />

      <h2 className="text-center py-2">Medicine</h2>
      <div className="mx-md-5 px-md-5 mx-4 bg-light row row-cols-md-2 row-cols-1">
        <div
          className="col px-md-5 py-3"
          style={{ borderRight: "4px solid white" }}
        >
          <div className="d-flex justify-content-between flex-column flex-md-row">
            <Records handleRecordClick={handleRecordClick} />
            <div>
              <input
                type="text"
                className="form-label me-2 px-2"
                placeholder="Medicine and press enter"
                onKeyUp={search}
              />
              {cancelActive && (
                <button className="btn btn-outline-primary" onClick={onCancel}>
                  <i className="fas fa-xmark p-1"></i>
                </button>
              )}
            </div>
          </div>
          <div className="table-responsive">
            <table
              data-toggle="table"
              className="table table-light table-hover table-striped"
              data-pagination="true"
              data-search="true"
            >
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Medicine Name</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {value?.length ? (
                  value?.map((name, i) => (
                    <tr key={i}>
                      <td>{startValue + i}</td>
                      <td className="text-capitalize">{name?.medicine_name}</td>
                      <td>
                        <button
                          className="btn btn-danger py-0"
                          onClick={() => onDelete(name.id)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={3} className="text-center">
                      No Records
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <Paginate
            startValue={startValue}
            endValue={endValue}
            count={count}
            pageCount={pageCount}
            handlePageClick={handlePageClick}
          />
        </div>
        <div className="col p-5">
          <h4 className="text-center mb-5">Add Medicine</h4>
          <h5>Medicine Name</h5>
          <input
            className="mt-2 w-50"
            type="text"
            onChange={onChange}
            value={medicine}
          />
          <div className="text-center mt-5">
            <button className="btn btn-primary px-4" onClick={addMedicine}>
              Add
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Medicine;
